import React from "react";
import { FitnessInstructorController } from "./FitnessInstructor";
import { RouteAndPageProps, getValuesCaseInsensitive } from "./Tools";
import { Assert } from "Tools";

const routeTable: {
  [K: string]: (props: RouteAndPageProps) => JSX.Element;
} = {
  FitnessInstructor: FitnessInstructorController,
};

export function ControllerRouter(props: RouteAndPageProps) {
  const controllers = getValuesCaseInsensitive(
    routeTable,
    props.controllerName,
  );
  Assert.hard(
    controllers.length > 0,
    `Controller ${props.controllerName} not found`,
  );
  Assert.hard(
    controllers.length < 2,
    `Multiple controllers for ${props.controllerName} found`,
  );
  const Controller = controllers[0];
  return <Controller {...props} />;
}
